var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBaseModal',_vm._g({attrs:{"title":_vm.title,"modal-width":800,"expand-content":""}},_vm.$listeners),[_c('AppQuoteWizard',{attrs:{"unit":_vm.unitToQuote}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }